import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingAccount {
}
ApiEpBillingAccount.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/account/`,
    method: "GET",
    query: req === null || req === void 0 ? void 0 : req.query,
});
ApiEpBillingAccount.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/account/${req.path.id}`,
    method: "GET",
});
//# sourceMappingURL=account.js.map